<h3>{{ 'aproveIdeaModal.authors' | translate }}</h3>
<form [formGroup]="formAuthor" class="container mb-5" (change)="setInforsOfFormAuthors()" (ngSubmit)="seveAuthors()">
    <div formArrayName="authors">
        <div *ngFor="let author of authorForms.controls; let i = index" class="row mb-3">
            <div *ngIf="!author.value.remove" class="border-bottom border-primary w-100">
                <h5 *ngIf="author.value.new">{{ 'aproveIdeaModal.infoAuthorNovo' | translate }}</h5>
                <h5 *ngIf="author.value.edit">{{ 'aproveIdeaModal.infoAuthorEdit' | translate }}</h5>
                <h5 *ngIf="author.value.changed">{{ 'aproveIdeaModal.infoAuthorChanged' | translate }}</h5>
                <span *ngIf="author.value.isMain">{{ 'aproveIdeaModal.authorMain' | translate }}</span>
                <div [formGroupName]="i" class="d-flex flex-row  flex-wrap mb-3 align-content-center">
                    <div class="d-flex flex-row flex-wrap">
                        <div class="p-2 flex-grow-1">
                            <label class="col-form-label label-custom">
                                {{ 'name' | translate }}:
                                <input type="text" class="form-control" formControlName="name" placeholder="Name" [ngClass]="{ 'is-invalid': author.controls.name.errors?.required, 'is-valid': author.controls.name?.valid }" [attr.readonly]="(!author.valid && author.value.edit) ? true : null"/>
                            </label>
                        </div>
                        <div class="p-2">
                            <label class="col-form-label label-custom">
                                {{ 'aproveIdeaModal.re' | translate }}:
                                <input type="text" class="form-control" formControlName="re" placeholder="RE" [ngClass]="{ 'is-invalid': author.controls.re.errors?.required, 'is-valid': author.controls.re?.valid }" [attr.readonly]="(!author.valid && author.value.edit) ? true : null"/>
                            </label>
                        </div>
                        <div class="p-2">
                            <label class="col-form-label label-custom">
                                {{ 'email' | translate }}:
                                <input type="text" class="form-control" formControlName="email" placeholder="Email" [ngClass]="{ 'is-invalid': author.controls.email.errors?.required, 'is-valid': author.controls.email?.valid }"  [attr.readonly]="(!author.valid && author.value.edit) ? true : null"/>
                            </label>
                        </div>
                    </div>

                    <!-- Section buttons -->
                    <!-- <button  type="button" *ngIf="!author.value.changed && !author.value.setMain && !author.value.new" data-toggle="tooltip" data-placement="top" title="{{ 'aproveIdeaModal.editAuthor' | translate }}">
                        <svg-icon class="is-cursor" src="assets/svg/edit.svg" (click)="changeAuthor(i)" class="align-items-center p-2 mt-3"></svg-icon>
                    </button> -->
                    <button  type="button" *ngIf="!author.value.changed && !author.value.edit && !author.value.new && !author.value.isMain" data-toggle="tooltip" data-placement="top" title="{{ 'aproveIdeaModal.removedAuthor' | translate }}">
                        <svg-icon class="is-cursor" src="assets/svg/trash-fill.svg" (click)="removeAuthor(i)" class="align-items-center p-2 mt-3"></svg-icon>
                    </button>
                    <button  type="button" *ngIf="!author.value.changed && !author.value.edit && !author.value.isMain" data-toggle="tooltip" data-placement="top" title="{{ 'aproveIdeaModal.setMainAuthor' | translate }}">
                        <svg-icon class="is-cursor" src="assets/svg/check-fill.svg" (click)="setMain(i)" class="align-items-center p-2 mt-3"></svg-icon>
                    </button>
                    <button  type="button" *ngIf="!author.value.new && !author.value.changed" data-toggle="tooltip" data-placement="top" title="{{ 'aproveIdeaModal.changedAuthor' | translate }}">
                        <svg-icon class="is-cursor" src="assets/svg/exchanges-black.svg" (click)="changedAuthor(i)" class="align-items-center p-2 mt-3"></svg-icon>
                    </button>
                    <button  type="button" *ngIf="author.value.new || !author.value.edit && author.value.changed" data-toggle="tooltip" data-placement="top" title="{{ 'aproveIdeaModal.removedFormAuthor' | translate }}">
                        <svg-icon class="is-cursor" src="assets/svg/close-secondary-fill.svg" (click)="removeFormAuthor(i)" class="align-items-center p-2 mt-3"></svg-icon>
                    </button>

                    <!-- Fields extras -->
                    <div *ngIf="(author.value.edit || author.value.changed || author.value.new )" class="d-flex flex-row flex-wrap">
                        <div class="p-2">
                            <label class="col-form-label label-custom">
                                Cpf:
                                <input type="text" class="form-control" formControlName="cpf" (blur)="onBlurCpf(i)" placeholder="Cpf" [ngClass]="{ 'is-invalid': author.controls.cpf.errors?.required || author.controls.cpf?.errors?.invalidCpf, 'is-valid': author.controls.cpf?.valid }" [attr.readonly]="(!author.valid && author.value.edit) ? true : null"/>
                            </label>
                        </div>
                        <div class="p-2">
                            <label class="col-form-label label-custom">
                                {{ 'aproveIdeaModal.jobRole' | translate }}:
                                <input type="text" class="form-control" formControlName="jobRole" placeholder="{{ 'aproveIdeaModal.jobRole' | translate }}" [ngClass]="{ 'is-invalid': author.controls.jobRole.errors?.required, 'is-valid': author.controls.jobRole?.valid }" [attr.readonly]="(!author.valid && author.value.edit) ? true : null"/>
                            </label>
                        </div>
                        <div class="p-2">
                            <label class="col-form-label label-custom">
                                {{ 'aproveIdeaModal.customCenter' | translate }}:
                                <input type="text" class="form-control" formControlName="costCenter" placeholder="{{ 'aproveIdeaModal.customCenter' | translate }}" [ngClass]="{ 'is-invalid': author.controls.costCenter.errors?.required, 'is-valid': author.controls.costCenter?.valid }" [attr.readonly]="(!author.valid && author.value.edit) ? true : null"/>
                            </label>
                        </div>
                        <div class="p-2">
                            <label class="col-form-label label-custom">
                                {{ 'aproveIdeaModal.areaAuthor' | translate }}:
                                <input type="text" class="form-control" formControlName="area" placeholder="{{ 'aproveIdeaModal.areaAuthor' | translate }}" [ngClass]="{ 'is-invalid': author.controls.area.errors?.required, 'is-valid': author.controls.area?.valid}" [attr.readonly]="(!author.valid && author.value.edit) ? true : null"/>
                            </label>
                        </div>
                        <div class="p-2"  *ngIf="author.value.changed" formGroupName="parent">
                            <label class="col-form-label">
                                {{ 'aproveIdeaModal.changedTargetAuthor' | translate }}:
                                <input type="text" class="form-control"  formControlName="name" />
                            </label>
                        </div>
                        <div class="p-2 w-75" *ngIf="author.value.changed">
                            <label class="col-form-label w-100">
                                {{ 'aproveIdeaModal.authorChangeReason' | translate }}:
                                <input type="text" class="form-control" formControlName="justification" placeholder="{{ 'aproveIdeaModal.authorChangeReason' | translate }}" [ngClass]="{ 'is-invalid': author.controls.justification.errors?.required, 'is-valid': author.controls.justificativa?.valid}"/>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- <div *ngFor="let error of getErrorsForm(author)" class="d-flex flex-row flex-wrap">
                	<p *ngIf="error?.cpf">{{ 'aproveIdeaModal.errorCpf' | translate }}</p>
                </div> -->
            </div>
            <br>
        </div>
    </div>
  <button class="btn btn-primary" type="button" (click)="addAuthor()">{{ 'aproveIdeaModal.addAuthor' | translate }}</button>
  <button class="btn btn-primary ml-5" type="submit" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">{{ 'aproveIdeaModal.buttonSaveAuthor' | translate }}</button>

  <div *ngIf="this.formAuthor.errors?.maxAuthorsValidated" [ngClass]="{'show': this.formAuthor.errors?.maxAuthorsValidated}">
    <div class="collapse mt-4" id="collapseExample">
        <div class="card card-body">
            {{ 'aproveIdeaModal.errorQuantityAuthor' | translate: { quantity: this.formAuthor.errors?.numberAuthors, author: this.formAuthor.errors?.stringAuthor  } }}
        </div>
    </div>
  </div>

  <div *ngIf="statusCode">
    <div class="collapse mt-4 alert alert-success" id="collapseExample"  [ngClass]="{'show': statusCode}">
        <div class="card card-body">
        	{{ 'aproveIdeaModal.messageSuccess' | translate }}
        </div>
    </div>
  </div>

  <!-- <div *ngIf="hasRequiredError || hasRequiredErrorSave">
    <div class="collapse mt-4" id="collapseExample">
        <div class="card card-body">
        	{{ 'aproveIdeaModal.errorRequired' | translate }}
        </div>
    </div>
  </div> -->
</form>
